import { useContext, useState } from 'react'
import { AllCommentsContext } from '../context/allComentsContext';
import toast from 'react-hot-toast';

const useEditComment = (email:string,commentInfo:string,id:number,setdisplayEdit:Function) => {
  const {updateComment} = useContext(AllCommentsContext);
  const [emailToEdit, setemailToEdit] = useState(email);
  const [commentInfoToEdit, setcommentInfoToEdit] = useState(commentInfo);
  const editComment = async()=>{
    if(email==="" ||  commentInfoToEdit ===''){
      return toast.error('You need to fill all the fields');
    }
    setemailToEdit("");
    setcommentInfoToEdit("");
    setdisplayEdit(false);
    await updateComment(id,emailToEdit,commentInfoToEdit)
    return toast.success('The comment was edited');
  }
  return {
      emailToEdit,setemailToEdit,commentInfoToEdit,setcommentInfoToEdit,editComment
  }
}

export default useEditComment